module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.2c157a50.ttf";